import React, { useEffect, useState } from 'react'

function CurrencySelector({currency, setCurrency, currencies}) {

    const [currenciesFiltered, setCurrenciesFiltered] = useState([])
    const [searchTerm, setSearchTerm] = useState("");


    function filterCurrencies(currencies) {

        const currenciesFiltered = currencies.filter(currency => currency.currencyName.toLowerCase().includes(searchTerm.toLowerCase()))
        console.log(currenciesFiltered)
        return currenciesFiltered

    }
    useEffect(() => {

        if (searchTerm !== "") {
            const currenciesFilteredArr = filterCurrencies(currencies)
            setCurrenciesFiltered(currenciesFilteredArr)
            console.log(currenciesFilteredArr)
            if (currenciesFilteredArr.length === 1) {
                setCurrency(currenciesFilteredArr[0].ticker)
            }
        } else {
            setCurrenciesFiltered(currencies)
        }

    }, [searchTerm])

    return (
        <React.Fragment>
            <div className="form-group">
                <label>Søk valuta</label>
                <input className="form-control mb-2" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder='Search currency' />
                
            </div>
            <div className='form-group my-3'>
            <label>Velg valuta ({currency ? currency : "Ingen valuta valgt"})</label><br/>
                <select className="form-control" onChange={e => setCurrency(e.target.value)}>
                    {currenciesFiltered.length ? currenciesFiltered.map((currency, index) => {
                            return <option key={index} value={currency.ticker}>{currency.currencyName} ({currency.ticker})</option>
                        })
                    :
                        currencies.map((currency, index) => {
                            return <option key={index} value={currency.ticker}>{currency.currencyName} ({currency.ticker})</option>
                        })
                    }
                </select>
            </div>
        </React.Fragment>
    )
}
export default CurrencySelector